<template>
	<div class="page">
		<add-new-post @postAdded="postAdded"/>
		<posts ref="postList"/>
	</div>
</template>

<script>
import AddNewPost from '@/components/wall/AddNewPost'
// import ToDoList from '@/components/wall/ToDoList'
// import Activities from "@/components/wall/Activities"; // Removed
// import Notes from "@/components/wall/Notes";
import Posts from "@/components/wall/Posts";
export default {
	name: 'Home',
	components: {
		AddNewPost,
		// ToDoList,
		// Activities, // Removed
		// Notes,
		Posts,
	},
	data() {
		return {
			loading: {
				wall: true
			},
			group: null,
			drawer: true,
			items: [
				{
					id: 1,
					message: "TEXT TEXT TEXT"
				}
			],
		}
	},
	methods: {
		postAdded() {
			this.$refs.postList.getPosts();
		}
	},
}
</script>

